import { CalendarDate, DateDuration } from '@internationalized/date';
import classNames from 'classnames';
import { useMemo } from 'react';
import { Calendar, CalendarProps } from 'react-aria-components';

import BaseCalendar from './components/BaseCalendar/BaseCalendar';
import DetailLevel from './types/DetailLevel';

import styles from './DateCalendar.module.css';

type DateCalendarProps = Pick<
    CalendarProps<CalendarDate>,
    | 'value'
    | 'maxValue'
    | 'minValue'
    | 'defaultValue'
    | 'onChange'
    | 'onFocusChange'
    | 'defaultFocusedValue'
    | 'focusedValue'
    | 'isDateUnavailable'
> & {
    visibleMonths?: number;
    defaultDetailLevel?: DetailLevel;
    maxDetailLevel?: DetailLevel;
    minDetailLevel?: DetailLevel;
    showDatesOutsideMonth?: boolean;
    preventHeightChange?: boolean;
};

const DateCalendar = ({
    visibleMonths = 1,
    defaultDetailLevel,
    maxDetailLevel,
    minDetailLevel,
    showDatesOutsideMonth,
    preventHeightChange = false,
    ...calendarProps
}: DateCalendarProps) => {
    const visibleDuration: DateDuration = useMemo(
        () => ({ months: visibleMonths }),
        [visibleMonths]
    );

    return (
        <Calendar
            className={classNames(styles.Root, {
                [styles.preventHeightChange]: preventHeightChange,
            })}
            pageBehavior="single"
            visibleDuration={visibleDuration}
            {...calendarProps}
        >
            <BaseCalendar
                visibleMonths={visibleMonths}
                defaultDetailLevel={defaultDetailLevel}
                maxDetailLevel={maxDetailLevel}
                minDetailLevel={minDetailLevel}
                showDatesOutsideMonth={showDatesOutsideMonth}
            />
        </Calendar>
    );
};

export default DateCalendar;
